import { FC, useEffect, useState } from 'react'
import { isOpenFinRuntime } from '../../containers/OpenFin/helpers'
import { fetchAlertFilters } from '../../store/alertFilter/actions'
import { getAlertFilters } from '../../store/alertFilter/selectors'
import { useAppDispatch, useAppSelector } from '../../store/types'
import ComponentHeader from '../ComponentHeader/ComponentHeader'
import Modal from '../GenericModal/Modal'
import AlertFilterEdit from './AlertFilterEdit'
import AlertFilterList from './AlertFilterList'

import styles from './AlertFilter.module.scss'

export interface Props {
  closeFunc: () => void
}
const AlertFilterEditor: FC<Props> = ({ closeFunc }) => {
  const isOpenFin = isOpenFinRuntime()
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(fetchAlertFilters())
  }, [])
  const alertFilters = useAppSelector(getAlertFilters)
  const selectedId = alertFilters.length > 0 ? alertFilters[0].id : 0
  const [selectedAlertFilterId, setSelectedAlertFilterId] = useState(selectedId)

  const contentModal = (
    <>
      {isOpenFin && <title>Alert Manager</title>}
      <ComponentHeader title="Alert Manager" />
      <AlertFilterList
        filters={alertFilters}
        selectAlertFilterId={setSelectedAlertFilterId}
        selectedAlertFilterId={selectedAlertFilterId}
      />
      <AlertFilterEdit
        filterId={selectedAlertFilterId}
        closeFunc={closeFunc}
        key={selectedAlertFilterId}
      />
    </>
  )

  return isOpenFin ? (
    <div className={styles.openFinLayout}>{contentModal}</div>
  ) : (
    <Modal>{contentModal}</Modal>
  )
}

export default AlertFilterEditor
